

import { useEffect, useRef, useState } from "react";
import { fetchFocusCities } from "../layers/fetchLayers.us";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { cartoBasemapUrl } from "../config/carto";
import MapLoadingOverlay from "./MapLoadingOverlay";


type Props = {
  showRoutes: boolean;
  filters: {
    drive: boolean;
    indirect: boolean;
    direct: boolean;
  };
};

async function fetchDriveRoute() {
  const url =
    "https://router.project-osrm.org/route/v1/driving/-86.1581,39.7684;-79.9959,40.4406?overview=full&geometries=geojson";

  const response = await fetch(url);
  const data = await response.json();

  return data.routes[0].geometry.coordinates;
}

export default function FocusCitiesMapUS({ showRoutes, filters }: Props) {
  const mapRef = useRef<L.Map | null>(null);
  const layersRef = useRef<L.LayerGroup | null>(null);
  const resetView = () => {
  mapRef.current?.setView([38.5, -84], 5, {
    animate: true,
  });
};

   const cityPoints = [
  { code: "MKE", name: "Milwaukee", center: L.latLng(43.053, -87.943) },
  { code: "CVG", name: "Cincinnati", center: L.latLng(39.1031, -84.5120) },
  { code: "CMH", name: "Columbus", center: L.latLng(39.9623, -83.0007) },
  { code: "CLE", name: "Cleveland", center: L.latLng(41.4993, -81.6944) },
  { code: "IND", name: "Indianapolis", center: L.latLng(39.7684, -86.1581) },
  { code: "PIT", name: "Pittsburgh", center: L.latLng(40.4406, -79.9959) },
  { code: "STL", name: "St. Louis", center: L.latLng(38.6481, -90.2122) },
  { code: "RIC", name: "Richmond", center: L.latLng(37.5407, -77.4360) },
  { code: "BNA", name: "Nashville", center: L.latLng(36.1627, -86.7816) },
  { code: "RDU", name: "Raleigh", center: L.latLng(35.7796, -78.6382) },
  { code: "MEM", name: "Memphis", center: L.latLng(35.1436, -89.9937) },
  { code: "BHM", name: "Birmingham", center: L.latLng(33.5186, -86.8104) },
  { code: "TYS", name: "Knoxville", center: L.latLng(35.9606, -83.9207) },
  { code: "MSY", name: "New Orleans", center: L.latLng(29.9561, -90.0734) },
  { code: "AVL", name: "Asheville", center: L.latLng(35.5954, -82.5508) },
  { code: "ORD", name: "Chicago O'Hare", center: L.latLng(41.9742, -87.9073) },
{ code: "ATL", name: "Atlanta", center: L.latLng(33.6407, -84.4277) },
{ code: "CLT", name: "Charlotte", center: L.latLng(35.2140, -80.9431) },
{ code: "IAD", name: "Washington Dulles", center: L.latLng(38.9531, -77.4565) },
];
const brandLogos = [
  { src: "photos/logo_focus_cities/harley.png", lat: 43.20, lng: -88.20 },
  { src: "photos/logo_focus_cities/indy500.png", lat: 39.92, lng: -86.28 },
  { src: "photos/logo_focus_cities/fedex.png", lat: 35.05, lng: -90.25 },
  { src: "photos/logo_focus_cities/heinz.png", lat: 40.52, lng: -80.12 },
  { src: "photos/logo_focus_cities/bush.jpg", lat: 36.10, lng: -84.05 },
  { src: "photos/logo_focus_cities/domino.png", lat: 29.90, lng: -90.20 },
  { src: "photos/logo_focus_cities/IBM.png", lat: 35.92, lng: -78.82 },
  { src: "/photos/logo_focus_cities/malboro.png", lat: 39.80, lng: -77.80 },
{ src: "/photos/logo_focus_cities/oreos.jpg", lat: 37.25, lng: -76.95 },
  { src: "photos/logo_focus_cities/mercedes.jpg", lat: 33.35, lng: -86.95 },
  { src: "photos/logo_focus_cities/smuckers.jpg", lat: 41.35, lng: -81.55 },
  { src: "photos/logo_focus_cities/wendys.jpg", lat: 40.08, lng: -82.90 },
];

const WORD_CLOUD = [
  { word: "Harley Davidson", lat: 39.8, lon: -84.3, size: 26 },
  { word: "Indy 500", lat: 41.0, lon: -86.5, size: 20 },
  { word: "Super Hornet", lat: 37.7, lon: -88.0, size: 24 },
  { word: "Country music", lat: 34.4, lon: -82.0, size: 18 },
  { word: "Domino Sugar", lat: 38.8, lon: -85.8, size: 22 },
  { word: "Bush Brothers", lat: 40.8, lon: -83.8, size: 17 },
  { word: "Marlboro", lat: 36.3, lon: -81.8, size: 19 },
  { word: "Oreo", lat: 33.9, lon: -84.0, size: 16 },
  { word: "Heinz", lat: 35.045631, lon: -85.309677, size: 21 },
  { word: "Smuckers", lat: 31.0, lon: -90.0, size: 18 },
  { word: "Wendy’s", lat: 35.0, lon: -81.5, size: 23 },
  { word: "Parker Hannifin", lat: 32.4, lon: -87.5, size: 20 },
  { word: "Eli Lilly", lat: 35.1, lon: -90.3, size: 16 },
  { word: "Rock n Roll", lat: 44, lon: -90, size: 21 },
  { word: "Mercedes-Benz", lat: 43.0, lon: -89.0, size: 18 },
  { word: "Creole & Cajun", lat: 42., lon: -90.5, size: 23 }
];

const [textCollapsed, setTextCollapsed] = useState(false);
  const [focusCities, setFocusCities] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchFocusCities().then((data) => {
  setFocusCities(data);
  setLoading(false);
  console.log(data);
});
  }, []);


async function fetchHeartRoadRoute(points: [number, number][]) {
  const coords = points
    .map(([lat, lng]) => `${lng},${lat}`)
    .join(";");

  const url =
    `https://router.project-osrm.org/route/v1/driving/${coords}` +
    `?overview=full&geometries=geojson`;

  const response = await fetch(url);
  const data = await response.json();

  return data.routes[0].geometry.coordinates;
}

  useEffect(() => {
    if (mapRef.current) return;
    const map = L.map("focus-cities-map", {
      center: [36, -90],
      zoom: 5,
      zoomControl: false,
      scrollWheelZoom: true,
      attributionControl: false,
      preferCanvas: true,
    });

    L.tileLayer(cartoBasemapUrl()).addTo(map);
    mapRef.current = map;
    layersRef.current = L.layerGroup().addTo(map);

   




}, []);


useEffect(() => {
  if (!layersRef.current) return;

  layersRef.current.clearLayers();

  // ============================================================
  // WORD CLOUD
  // ============================================================

  WORD_CLOUD.forEach((item, index) => {
    const icon = L.divIcon({
      className: "focus-word-cloud-icon",
      html: `
        <span
          class="focus-word-cloud-word"
          style="
            font-size:${item.size}px;
            animation-delay:${index * 0.18}s;
          "
        >
          ${item.word}
        </span>
      `,
      iconSize: undefined,
    });

    L.marker(
      [item.lat, item.lon],
      {
        icon,
        interactive: false,
      }
    ).addTo(layersRef.current!);
  });

}, []);


  return (
  <>
    <div
      id="focus-cities-map"
      style={{ width: "100%", height: "100%" }}
    />
<div className="focus-cities-zoom">
  <button title="Zoom in" onClick={() => mapRef.current?.zoomIn()}>
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
      <path d="M12 5v14M5 12h14" />
    </svg>
  </button>

  <button title="Zoom out" onClick={() => mapRef.current?.zoomOut()}>
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
      <path d="M5 12h14" />
    </svg>
  </button>

  <button title="Reset view" onClick={resetView}>
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
      <path d="M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
    </svg>
  </button>
</div>
    <MapLoadingOverlay
      loading={loading}
      label="focus cities"
    />
  </>
);

}
